<template>
  <div v-loading="loading" class="rj-page-card">
    <div class="rj-page-card__title">
      收货信息
    </div>
    <div class="rj-page-card__content">
      <Collapse :open="true">
        <div slot="header">
          <span>配送至：</span>
          <div v-if="this.form.receiptAddressId" class="adressBox">
            <div v-if="address.isDefault" class="defTab">
              默认
            </div>
            <div class="item">
              {{ address.receiverName }}
            </div>
            <div class="item">
              {{ address.province }}
            </div>
            <div class="item">
              {{ address.city }}
            </div>
            <div class="item">
              {{ address.county }}
            </div>
            <div class="item">
              {{ address.receiptAddress }}
            </div>
            <div class="item">
              {{ address.receiverPhone }}
            </div>
          </div>
          <el-button v-if=" address.receiverName" type="text" style="padding: 0;margin-left: 15px" @click.stop="showAddress=true">
            更改地址
          </el-button>
          <el-button v-else type="text" style="padding: 0;margin-left: 15px" @click.stop="showAddress=true">
            选择地址
          </el-button>
        </div>
        <div style="padding: 20px">
          <el-form :inline="true">
            <el-form-item v-if="!(form.departmentCode && (form.departmentCode.includes('000063') || form.departmentCode.includes('000036') || form.departmentCode.includes('000101')))">
              <el-date-picker v-model="allAttribute.time" type="date" value-format="yyyy-MM-dd" placeholder="选择期望发货日期" />
            </el-form-item>
            <el-form-item>
              <el-select v-model="allAttribute.freight" placeholder="请选择货运属性">
                <el-option v-for="(value, key) in freightProperty" :key="key"
                           :label="value"
                           :value="key"
                />
              </el-select>
            </el-form-item>
            <el-form-item>
              <el-button type="primary" @click="batchSettings">
                批量设置
              </el-button>
              <el-button type="default" @click="setMaterialNum()">
                设置料号
              </el-button>
              <el-button type="default" @click="addNewRow">
                添加产品行
              </el-button>
              <el-button type="default" @click="batchDeatail">
                删除勾选产品行
              </el-button>
            </el-form-item>
          </el-form>
          <el-table ref="productTable" :data="productList"
                    border
                    style="width: 100%"
                    show-summary
                    :summary-method="getSummaries"
                    class="productTable"
                    @selection-change="handleSelectionChange"
          >
            <el-table-column
              type="selection"
              width="55"
              fixed="left"
            />
            <el-table-column type="index" width="70" label="序号" align="left">
              <template v-slot="{row,$index}">
                {{ row.itemIndex=$index+1 }}
              </template>
            </el-table-column>
            <el-table-column prop="productCode" label="销售代码" align="left" min-width="150" />
            <el-table-column prop="productName" label="产品型号" align="left" min-width="150">
              <template v-slot="{row}">
                <choose-product ref="chooseProduct" :row="row" :form="form" />
              </template>
            </el-table-column>
            <el-table-column prop="productCode" label="料号" align="left" width="120">
              <template v-slot="{row,$index}">
                <el-button type="text" :disabled="row.exclusiveMaterialNumber!=''&&row.exclusiveMaterialNumber!=null" @click="setMaterialNum(row,$index)">
                  {{ row.materialNumberId?row.materialNumberId:'选择料号' }}
                </el-button>
              </template>
            </el-table-column>
            <el-table-column prop="productNum" label="数量" align="left" width="90">
              <template v-slot="{row}">
                <el-input-number v-model="row.productNum" :min="1" :controls="false" style="width:100%;" @change="handleChange" />
              </template>
            </el-table-column>
            <el-table-column prop="productPriceSigle" label="单价" align="right" header-align="left" width="135">
              <template v-slot="{row}">
                <el-input-number v-model="row.productPriceSigle" :min="0" :controls="false" style="width:100%;" @change="handleChange" />
              </template>
            </el-table-column>
            <el-table-column prop="orderAmount" label="订单金额" align="right" header-align="left" width="135" />
            <el-table-column prop="settlementAmount" label="实际结算金额" align="right" header-align="left" width="135">
              <template v-slot="{row}">
                <el-input-number v-model="row.settlementAmount" :min="0" :controls="false" style="width:100%;" />
              </template>
            </el-table-column>
            <el-table-column prop="isBorrow" label="测试借条转订单" align="left" width="110">
              <template v-slot="{row}">
                <el-checkbox v-model="row.isBorrow" />
              </template>
            </el-table-column>
            <el-table-column prop="freightProperty" label="货运属性" align="left" width="130">
              <template v-slot="{row}">
                <el-select v-model="row.freightProperty" placeholder="货运属性">
                  <el-option v-for="(value, key) in freightProperty" :key="key"
                             :label="value"
                             :value="key"
                  />
                </el-select>
              </template>
            </el-table-column>
            <el-table-column prop="powerCordSpecification" label="电源线规格" align="left" width="130">
              <template v-slot="{row, $index}">
                <el-select v-model="row.powerCordSpecification" :disabled="!row.isHavePowerCord" @change="powerCordSpecificationChange($index, $event)">
                  <el-option
                    v-for="(value, key) in (Number(row.powerCordPin) === 2 ? powerCordData.twoPinPowerCordList : powerCordData.threePinPowerCordList)"
                    :key="key" :label="value.constantName"
                    :value="value.constantName"
                  />
                </el-select>
              </template>
            </el-table-column>
            <!-- <el-table-column prop="expectedDeliveryDate" label="期望发货日期" align="left" width="150">
              <template v-slot="{row}">
                <el-date-picker v-model="row.expectedDeliveryDate" type="date" style="width:100%;" value-format="yyyy-MM-dd" placeholder="期望发货日期" :clearable="false" />
              </template>
            </el-table-column> -->
            <template v-if="form.departmentCode && (form.departmentCode.includes('000063') || form.departmentCode.includes('000036') || form.departmentCode.includes('000101') > -1)">
              <el-table-column prop="expectedDeliveryDate" label="期望齐套日期" align="left" width="150">
                <template v-slot="{row}">
                  {{ row.expectedDeliveryDate ? row.expectedDeliveryDate : '——' }}
                </template>
              </el-table-column>
            </template>
            <template v-if="form.departmentCode && (form.departmentCode.includes('000063') || form.departmentCode.includes('000036') || form.departmentCode.includes('000101') > -1)">
              <el-table-column prop="expectedShippingDate" label="期望发货日期" align="left" width="150">
                <template v-slot="{row}">
                  {{ row.expectedShippingDate ? row.expectedShippingDate : '——' }}
                </template>
              </el-table-column>
            </template>
            <template v-if="form.departmentCode && (form.departmentCode.includes('000063') || form.departmentCode.includes('000036') || form.departmentCode.includes('000101') > -1)">
              <el-table-column prop="expectedArrivalDate" label="期望到货日期" align="left" width="150">
                <template v-slot="{row}">
                  {{ row.expectedArrivalDate ? row.expectedArrivalDate : '——' }}
                </template>
              </el-table-column>
            </template>
            <template v-if="!(form.departmentCode && (form.departmentCode.includes('000063') || form.departmentCode.includes('000036') || form.departmentCode.includes('000101')))">
              <!-- <el-table-column fixed prop="expectedDeliveryDate" label="期望发货日期" align="left" width="150" /> -->
              <el-table-column prop="expectedDeliveryDate" label="期望发货日期" align="left" width="150">
                <template v-slot="{row}">
                  <el-date-picker v-model="row.expectedDeliveryDate" type="date" style="width:100%;" value-format="yyyy-MM-dd" placeholder="期望发货日期" :clearable="false" />
                </template>
              </el-table-column>
            </template>
            <el-table-column prop="beforeSplitProductPriceSigle" label="拆分前单价" align="right" header-align="left" width="100">
              <template v-slot="{row}">
                <el-input-number v-model="row.beforeSplitProductPriceSigle" :min="0" :controls="false" style="width:100%;" />
              </template>
            </el-table-column>
            <el-table-column label="操作" align="left" fixed="right" width="100">
              <template v-slot="{row,$index}">
                <el-button type="text" style="padding: 0;" @click="copyRow(row,$index)">
                  <i class="el-icon-circle-plus-outline" style="font-size: 16px;" />
                </el-button>
                <el-button type="text" style="padding: 0;color: #F56C6C" @click="removeProduct($index)">
                  <i class="el-icon-delete" style="font-size: 16px;" />
                </el-button>
              </template>
            </el-table-column>
          </el-table>
        </div>
      </Collapse>
      <slot />
    </div>
    <address-box :prop-open.sync="showAddress" @chooseAddress="changeAddress" @ChangeDatas="ChangeDatas" />
    <material-num ref="MaterialNum" @chooseMateria="chooseMateria" />
  </div>
</template>
<script type="es6">

import Collapse from '@/components/Collapse';
import chooseProduct from '../../contractCommonInput/chooseProduct';
import MaterialNum from '../../contractCommonInput/MaterialNum';
import addressBox from '@/views/address/index.vue';
import { mapState } from 'vuex';
import { MathMulti, MathAdd, getNum, DateToStr } from '@/libs/util';
import Big from 'big.js';
import { getReceiptAddressInfoModel } from '@/API';
import eventBus from '../../../libs/eventBus';
export default {
  data () {
    return {
      allAttribute: {
        time: '',
        freight: '',
        btnNum: 0
      },
      multipleSelection: [],
      productList: [],
      showAddress: false,
      loading: false,
      address: {},
      powerCordData: {}
    };
  },
  props: {
    rebateAmount: {
      type: [String, Number],
      default: 0
    },
    rebate: {
      type: [Number],
      default: 1
    },
    salesType: {
      type: [String, Number],
      default: ''
    },
    contractType: {
      type: String,
      default: ''
    },
    communicationOrderDiscount: {
      type: [String, Number],
      default: 1
    },
    form: {
      type: Object,
      default: () => { return {}; }
    }
  },
  components: {
    Collapse,
    addressBox,
    chooseProduct,
    MaterialNum
  },
  computed: {
    ...mapState({
      freightProperty: state => state.enumeration.freightProperty
    }),
    // 数量总计
    AmountTotal () {
      let cont = 0;
      this.productList.forEach((item) => {
        if (item.productNum) {
          cont += item.productNum;
        }
      });
      return cont;
    },
    // 订单金额总计
    computePriceTotal () {
      let cont = 0;
      this.productList.forEach((item) => {
        // let itemcont = MathMulti(item.productNum, item.productPriceSigle);
        if (item.orderAmount) {
          cont = MathAdd(item.orderAmount, cont);
        }
      });
      cont = Number(cont).toFixed(2);
      this.Recalculation();
      return cont;
    },
    // 实际结算金额总计
    settlementSumTotal () {
      let cont = 0;
      this.productList.forEach((item) => {
        cont = MathAdd(cont, item.settlementAmount);
      });
      return cont;
    },
    // 拆分前单价总计
    beProductUnitPriceTotal () {
      // let cont = 0;
      // this.productList.forEach((item) => {
      //   let itemcont = MathMulti(item.productNum, item.beforeSplitProductPriceSigle);
      //   cont = MathAdd(itemcont, cont);
      // });
      // return cont;
      let cont = this.productList.reduce((pre, cur) => {
        return getNum(Big(getNum(cur.productNum)).times(getNum(cur.beforeSplitProductPriceSigle)).plus(pre).toString());
      }, 0);
      return cont;
    }
  },
  methods: {
    initData () {
    },
    // 批量删除
    batchDeatail () {
      if (this.multipleSelection.length === 0) {
        this.$message.error('请勾选需要删除产品行');
        return;
      }
      this.$confirm('是否删除勾选产品行?', '提示', {
        confirmButtonText: '删除',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        for (var i = 0; i < this.productList.length; i++) {
          for (var j = 0; j < this.multipleSelection.length; j++) {
            if (this.productList[i].itemIndex === this.multipleSelection[j].itemIndex) {
              this.productList.splice(i, 1);
            }
          }
        };
        this.multipleSelection = [];
      }).catch(() => {

      });
    },
    handleSelectionChange (val) {
      this.multipleSelection = val;
    },
    batchSettings () {
      let error = '';
      this.productList.forEach((item) => {
        if (this.allAttribute.time && !(this.form.departmentCode && (this.form.departmentCode.includes('000063') || this.form.departmentCode.includes('000036') || this.form.departmentCode.includes('000101')))) {
          let nowDateStr = DateToStr(new Date());
          if (new Date(this.allAttribute.time) >= new Date(nowDateStr)) {
            this.$set(item, 'expectedDeliveryDate', this.allAttribute.time);
          } else {
            error = '期望发货日期不能小于当前日期';
          }
        }
        if (this.allAttribute.freight) {
          this.$set(item, 'freightProperty', this.allAttribute.freight);
          // item.expectedDeliveryDate = this.allAttribute.time;
        }
      });
      if (error) {
        this.$notify.error({
          message: error
        });
      }
    },
    // 合计行的计算
    getSummaries (param) {
      // let allowsum = ['数量', '订单金额', '实际结算金额'];
      const { columns } = param;
      const sums = [];
      columns.forEach((column, index) => {
        if (index === 0) {
          sums[index] = '合计';
          return;
        }
        if (column.label === '数量') {
          sums[index] = this.AmountTotal;
          return;
        }
        if (column.label === '订单金额') {
          sums[index] = this.computePriceTotal;
          return;
        }
        if (column.label === '实际结算金额') {
          // this.baseInfo.finalNetSales = Number(this.settlementSumTotal).toFixed(2);
          sums[index] = Number(this.settlementSumTotal).toFixed(2);
          return;
        }
        if (column.label === '拆分前单价') {
          sums[index] = this.beProductUnitPriceTotal;
        }
      });
      return sums;
    },
    changeAddress (val) {
      // 选择其他地址
      this.address = val;
      this.showAddress = false;
      this.$emit('chooseAddress', val);
    },
    ChangeDatas () {
      // 地址选择 地址源地址列表发生变化，需要用当前地址id 重新查询地址信息
      if (this.address.id) {
        getReceiptAddressInfoModel(this.address.id).then((res) => {
          let json = res.data;
          if (json.status === '200') {
            if (!json.data.isDelete) {
              this.address = json.data;
            } else {
              this.address = {};
            }
          }
        }).catch(() => {

        });
      }
    },
    validate () {
      let error = '';
      if (!this.productList.length) {
        error = '请选择产品';
      }
      if (Number(this.beProductUnitPriceTotal) !== Number(this.computePriceTotal)) {
        error = '拆分前单价与订单金额不符';
      }
      this.productList.forEach((item) => {
        this.$delete(item, 'removeVisible');
        if (this.btnNum === 0) {
          if (!error) {
            if (!item.productCode) {
              error = '存在产品未选产品型号';
            } else if (!item.materialNumberId) {
              error = '存在产品未选择期料号';
            } else if (!item.expectedDeliveryDate && !(this.form.departmentCode && (this.form.departmentCode.includes('000063') || this.form.departmentCode.includes('000036') || this.form.departmentCode.includes('000101')))) {
              error = '存在产品未选择期望发货日期';
            } else if (!item.freightProperty) {
              error = '存在产品未选择货运属性';
            }
          }
        }
      });
      return new Promise((resolve, reject) => {
        if (error) {
          this.$notify.error({
            message: error
          });
          reject(new Error('产品验证失败'));
        } else {
          resolve({ productList: this.productList, actualSettlementAmount: Number(this.settlementSumTotal).toFixed(2), orderSales: this.computePriceTotal });
        }
      });
    },
    validatedrafts () {
      return new Promise((resolve, reject) => {
        resolve({ productList: this.productList, actualSettlementAmount: Number(this.settlementSumTotal).toFixed(2), orderSales: this.computePriceTotal });
      });
    },
    getOrderAmount (row) {
      let Amount = MathMulti(row.productNum, row.productPriceSigle);
      row.orderAmount = Number(Amount).toFixed(2);
      return row.orderAmount;
    },
    removeProduct (index) {
      this.$confirm('是否删除该产品?', '提示', {
        confirmButtonText: '删除',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        let list = this.productList;
        this.productList = [];
        this.$nextTick(() => {
          list.splice(index, 1);
          this.productList = list;
        });
      }).catch(() => {

      });
    },
    copyRow (row, index) {
      let newRow = JSON.parse(JSON.stringify(row));
      newRow.id = null;
      this.productList.splice(index + 1, 0, newRow);
    },
    addNewRow () {
      this.productList.push({
        orderAmount: 0,
        settlementAmount: 0,
        materialNumberId: '',
        productNum: 0,
        productPriceSigle: 0,
        beforeSplitProductPriceSigle: 0,
        isBorrow: false
      });
    },
    setMaterialNum (row, index) {
      if (!this.contractType) {
        this.$notify.error({
          message: '请先选择订单分类'
        });
        return;
      }
      let productAndMaterialGroup = [];
      let MaterialNumValues = {};
      if (!row) {
        this.productList.forEach((item, index) => {
          if (item.productCode) {
            productAndMaterialGroup.push({
              productSalesCode: item.productCode,
              productName: item.productName,
              powerCordSpecification: item.powerCordSpecification,
              exclusiveMaterial: item.materialNumberId || '',
              productNum: item.productNum,
              isHavePowerCord: item.isHavePowerCord || false,
              isTestOrder: item.isBorrow || false
            });
            MaterialNumValues[item.productCode] = {
              materialNumberId: item.materialNumberId,
              materialUnit: item.materialUnit
            };
          }
        });
      } else {
        if (row.productCode) {
          productAndMaterialGroup.push({
            productSalesCode: row.productCode,
            productName: row.productName,
            powerCordSpecification: row.powerCordSpecification,
            exclusiveMaterial: row.materialNumberId,
            productNum: row.productNum,
            isHavePowerCord: row.isHavePowerCord || false,
            isTestOrder: row.isBorrow || false
          });
          MaterialNumValues[row.productCode] = {
            materialNumberId: row.materialNumberId,
            materialUnit: row.materialUnit
          };
        } else {
          return;
        }
      }
      let param = {
        contractType: this.form.saleTypeName || '',
        contractNumber: this.form.contractNum,
        contractName: this.form.projectName || '',
        materialReqProductVOS: productAndMaterialGroup
      };
      if (['国际业务下单', '国际分销下单'].includes(this.form.contractType)) {
        param.soldCountry = this.form.soldCountry;
        param.orderUnit = this.form.orderUnit;
        param.orderType = this.form.contractType;
      }
      this.$refs.MaterialNum.showdialog(param, index, MaterialNumValues);
    },
    chooseMateria ({ list, RowIndex }) {
      if (RowIndex === 'all') {
        let cx = 0;
        this.productList.forEach((pro, index) => {
          let mate = list[index - cx];
          if (pro.productCode === mate.productSalesCode) {
            pro.materialNumberId = mate.selected;
            // 兼容字段materialUnit为空的时候
            pro.materialUnit = mate.materialUnit || '';
            pro.softFlag = mate.softFlag || '';
          }
          if (pro.exclusiveMaterialNumber) {
            cx++;
          }
        });
      } else {
        this.productList[RowIndex].materialNumberId = list[0].selected;
        this.productList[RowIndex].materialUnit = list[0].materialUnit;
        this.productList[RowIndex].softFlag = list[0].softFlag;
      }
    },
    async Recalculation () {
      await this.$nextTick();
      this.productList.forEach((item) => {
        this.getOrderAmount(item);
      });
    },
    handleChange () {
      this.Recalculation();
      this.$emit('change');
    },
    powerCordSpecificationChange (index, val) {
      // 解决试图不更新问题
      this.$delete(this.productList[index], 'powerCordSpecification');
      this.$set(this.productList[index], 'powerCordSpecification', val);
    }
  },
  created () {
    eventBus.$on('changePowerCord', (data) => {
      console.log(data);
      this.powerCordData = data.powerCordData;
    });
    eventBus.$on('btnType', (val) => {
      this.btnNum = val;
    });
  },
  beforeDestroy () {
    eventBus.$off('changePowerCord');
    eventBus.$off('btnType');
  },
  watch: {
    productList (val) {
      val.forEach((item, index) => {
        if (!item) {
          val.splice(index, 1);
        } else {
          if (!item.expectedDeliveryDate) {
            item.expectedDeliveryDate = null;
          }
          if (!item.expectedShippingDate) {
            item.expectedShippingDate = null;
          }
          if (!item.expectedArrivalDate) {
            item.expectedArrivalDate = null;
          }
        }
      });
      this.Recalculation();
    },
    communicationOrderDiscount () {
      this.Recalculation();
    }
  }
};
</script>
<style lang="scss" scoped>
  .productTable{
    .el-table__footer-wrapper tbody td{
      background: #fff;
    }
  }
  /* adress
-------------------------- */
  .adressBox{
    display: inline-block;
    .item{
      display: inline-block;
      margin-right: 6px;
    }
    .defTab{
      padding: 3px 10px;
      display: inline-block;
      background: #1b73ff;
      font-size: 12px;
      color: #fff;
      border-radius: 4px;
      margin-right: 15px;
    }
  }
</style>
